var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('gmap-map',{staticStyle:{"width":"100%","height":"100%"},attrs:{"center":_vm.center,"zoom":17}},[_c('GmapCustomMarker',{attrs:{"marker":_vm.center,"zIndex":0}},[_c('img',{staticClass:"marker-icon",attrs:{"src":_vm.markerIcon}})])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-52c5ed2e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/about/GoogleMaps.vue
// module id = null
// module chunks = 